import { render, staticRenderFns } from "./Medios.vue?vue&type=template&id=37b863c1&scoped=true"
import script from "./Medios.vue?vue&type=script&lang=js"
export * from "./Medios.vue?vue&type=script&lang=js"
import style0 from "./Medios.vue?vue&type=style&index=0&id=37b863c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b863c1",
  null
  
)

export default component.exports